import React, { Component } from 'react';

export class SublocationSearch extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <>
                <div className="sublocation-search">
                        <input autoFocus autocomplete="off" placeholder="Search by ID or Name" onChange={(event) => this.props.updateInputValue("sublocationInput", event.target.value)} value={this.props.sublocationInput} id='subloc-input' className='inventory-management-input'></input>
                    <button hidden onClick={(event) => this.props.findSublocation()} id='sublocation-search-submit' className='sublocation-search-submit'>Submit</button>
                </div>
            </>
        );
    }
}